import type { WidgetResponseSpec } from "../Processing/types";

/**
 * Fetch query results for a single widget (used when a widget is added or
 * refreshed independently of the full dashboard load).
 *
 * Replace the mock return with:
 *   const res = await axios.post(`${API_URL}/dashboard/${dashboardId}/widget/${widgetId}/data`);
 *   return res.data as WidgetResponseSpec;
 *
 * Endpoint: POST /api/dashboard/:dashboardId/widget/:widgetId/data
 */
export async function fetchWidgetData(
  _dashboardId: string,
  _widgetId: string,
): Promise<WidgetResponseSpec | null> {
  // TODO: replace with real API call
  void _dashboardId;
  void _widgetId;
  return null;
}
